import { SMS_CONSENT_PRIVACY_URL } from '@aslgo/shared';

/** Renders a consent string with the privacy-policy URL inside it turned into a
 *  real link. The string itself is never rewritten: what a guide reads has to
 *  stay character-for-character identical to what gets recorded against them
 *  (see SMS_CONSENT_TEXT), so this wraps the URL where it stands rather than
 *  swapping in friendlier link text.
 *
 *  At registration this copy lives inside the consent radio button's <label>,
 *  and a plain click on a link there must not select it — reading the policy is
 *  not consenting to texts. The HTML spec already says a label ignores clicks
 *  on interactive descendants, but jsdom (and so every test we could write)
 *  disagrees, so the navigation is done by hand and the click cancelled.
 *  Modified clicks fall through untouched, keeping open-in-new-tab working. */
export function ConsentText({ text }: { text: string }) {
  const at = text.indexOf(SMS_CONSENT_PRIVACY_URL);
  if (at === -1) return <>{text}</>;
  return (
    <>
      {text.slice(0, at)}
      <a
        href={SMS_CONSENT_PRIVACY_URL}
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => {
          if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
          e.preventDefault();
          e.stopPropagation();
          window.open(SMS_CONSENT_PRIVACY_URL, '_blank', 'noopener,noreferrer');
        }}
        className="underline hover:text-ink-800 dark:hover:text-ink-100"
      >
        {SMS_CONSENT_PRIVACY_URL}
      </a>
      {text.slice(at + SMS_CONSENT_PRIVACY_URL.length)}
    </>
  );
}
